import request from '@/api/request';
const defaultRequest = request();

export function getStatistics () {
  return defaultRequest({
    url: '/dashboard/statistics',
    method: 'get',
  });
}

export function getNewVehicles (params) {
  return defaultRequest({
    url: '/dashboard/newvehicle',
    method: 'get',
    params
  });
}

export function getNewAccounts (params) {
  return defaultRequest({
    url: '/dashboard/newaccount',
    method: 'get',
    params
  });
}



// WEBPACK FOOTER //
// ./src/api/dashboard.js